module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-6-a6da075e7479048d7653ac311adf0568.jpg";